'use client';
import { cn } from '@/lib/utils';
import { usePopupStore } from '@/stores/popup';
import useStore from '@/stores/useStore';
import React, { useEffect } from 'react';

export default function CustomPopup() {
  const show = useStore(usePopupStore, (state) => state.show);
  const type = useStore(usePopupStore, (state) => state.type);
  const message = useStore(usePopupStore, (state) => state.message);
  const closePopup = usePopupStore((state) => state.closePopup);

  const handleClose = () => {
    closePopup?.();
  };

  useEffect(() => {
    return () => {
      closePopup?.();
    };
  }, []);

  if (!show) {
    return <></>;
  }
  return (
    <div
      className={cn(
        'mb-[40px] mt-8 flex w-full animate-jump-in items-center gap-x-[10px] rounded-[5px] bg-[#D4F9E8] px-[30px] py-[30px] text-[#007F5F] lg:px-[40px]',
        type === 'error' && 'bg-red-600 font-semibold text-white',
        type === 'warn' && 'bg-primary-600 font-semibold text-white'
      )}
    >
      {type === 'success' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
        >
          <path
            d="M7.5 11.5625L9.9375 14L14 8.3125M20.5 10.75C20.5 12.0304 20.2478 13.2982 19.7578 14.4812C19.2678 15.6641 18.5497 16.7389 17.6443 17.6443C16.7389 18.5497 15.6641 19.2678 14.4812 19.7578C13.2982 20.2478 12.0304 20.5 10.75 20.5C9.46961 20.5 8.20176 20.2478 7.01884 19.7578C5.83591 19.2678 4.76108 18.5497 3.85571 17.6443C2.95034 16.7389 2.23216 15.6641 1.74217 14.4812C1.25219 13.2982 1 12.0304 1 10.75C1 8.16414 2.02723 5.68419 3.85571 3.85571C5.68419 2.02723 8.16414 1 10.75 1C13.3359 1 15.8158 2.02723 17.6443 3.85571C19.4728 5.68419 20.5 8.16414 20.5 10.75Z"
            stroke="#007F5F"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {type === 'error' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-6 w-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
          />
        </svg>
      )}
      <span className="flex flex-col">
        <span>
          {type === 'success' && 'Success'}
          {type === 'error' && 'Error'}
        </span>
        <span>{message}</span>
      </span>
      <button onClick={() => handleClose()} className="ml-auto" type="button">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.56066 5.43934C6.97487 4.85355 6.02513 4.85355 5.43934 5.43934C4.85355 6.02513 4.85355 6.97487 5.43934 7.56066L10.3787 12.5L5.43934 17.4393C4.85355 18.0251 4.85355 18.9749 5.43934 19.5607C6.02513 20.1464 6.97487 20.1464 7.56066 19.5607L12.5 14.6213L17.4393 19.5607C18.0251 20.1464 18.9749 20.1464 19.5607 19.5607C20.1464 18.9749 20.1464 18.0251 19.5607 17.4393L14.6213 12.5L19.5607 7.56066C20.1464 6.97487 20.1464 6.02513 19.5607 5.43934C18.9749 4.85355 18.0251 4.85355 17.4393 5.43934L12.5 10.3787L7.56066 5.43934Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>
  );
}
